import React from "react";
import { Col_12_8_6_4 } from "../../../components/col/Col_12_8_6_4";
import { Row10 } from "../../../components/row/Row10";
import LabelValor from "../../../components/label/LabelValor";
import { useSelector } from "react-redux";
import { AsesorServiciosGruas } from "./inputs/_AsesorServiciosGruas";

import { AsesorEscotel } from "./inputs/_AsesorEscotel";

import { Sucursal } from "./inputs/_Sucursal";
import { CampoTextoEditable } from "./inputs/_CampoTextoEditable";

export const Seccion2 = () => {
  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );

  return (
    <>
      <Row10>
        <Col_12_8_6_4>
          <CampoTextoEditable
            label="Tipo de vehículo"
            campo="tipoVehiculo"
            valor={c.tipoVehiculo}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <CampoTextoEditable label="Marca" campo="marca" valor={c.marca} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <CampoTextoEditable label="Modelo" campo="modelo" valor={c.modelo} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Color" valor={c.color} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Placas" valor={c.placas} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <CampoTextoEditable label="No. Serie" campo="serie" valor={c.serie} />
        </Col_12_8_6_4>
      </Row10>

      <Row10>
        <Col_12_8_6_4>
          <LabelValor label="Tipo de gestión" valor={c.tipoGestion} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Afectado" valor={c.afectado} />
        </Col_12_8_6_4>

        <Sucursal />
        <Col_12_8_6_4>
          <LabelValor label="Nombre de supervisor" valor={c.nombreSupervisor} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Nombre de abogado" valor={c.nombreAbogado} />
        </Col_12_8_6_4>

        <Col_12_8_6_4>
          <LabelValor label="Correo abogado" valor={c.correoAbogado} />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Proveedor concesionado"
            valor={c.proveedorConcesionado}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Concesionado homologado"
            valor={c.concesionadoHomologado}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Tel. concessionado" valor={c.telConcesionado} />
        </Col_12_8_6_4>
        <AsesorServiciosGruas />
        <AsesorEscotel />
        <Col_12_8_6_4>
          <LabelValor
            label="Observaciones generales"
            valor={c.observacionesGenerales}
          />
        </Col_12_8_6_4>
      </Row10>
    </>
  );
};
